import { api } from '../api';

// Unwrap the {success, data} ApiResponse envelope to the inner DTO.
const unwrap = (r) => r?.data ?? r;

// PageResponse → plain array (used for interaction timelines).
const toArray = (body) =>
  body?.data?.content
  ?? body?.content
  ?? (Array.isArray(body?.data) ? body.data : null)
  ?? (Array.isArray(body) ? body : []);

export default {
  list:         (params)   => api.get('/v1/customers', { params }).then(r => r.data),
  get:          (id)       => api.get(`/v1/customers/${id}`).then(r => r.data),
  history:      (id)       => api.get(`/v1/customers/${id}/history`).then(r => r.data),
  interactions: (id)       => api.get(`/v1/customers/${id}/interactions`).then(r => toArray(r.data)),
  timeline:     (id)       => api.get(`/v1/customers/${id}/timeline`).then(r => toArray(r.data)),
  create:       (body)     => api.post('/v1/customers', body).then(r => unwrap(r.data)),
  update:       (id, body) => api.put(`/v1/customers/${id}`, body).then(r => unwrap(r.data)),

  /* ── notes (persisted — see lib/useCustomerNotes.js) ── */
  // → [{ id, customerId, leadId, authorId, authorName, body, pinned, createdAt, updatedAt }]
  notes:        (id)             => api.get(`/v1/customers/${id}/notes`).then(r => toArray(r.data)),
  addNote:      (id, body)       => api.post(`/v1/customers/${id}/notes`, body).then(r => unwrap(r.data)),   // { body, leadId?, pinned? }
  updateNote:   (noteId, body)   => api.patch(`/v1/notes/${noteId}`, body).then(r => unwrap(r.data)),        // { body?, pinned? }
  deleteNote:   (noteId)         => api.delete(`/v1/notes/${noteId}`).then(r => r.data),

  /* ── next event per customer (E11) ──
   * → { [customerId]: { nextEvent: NextEventDto|null, openLeads: n } }
   * A 404 means the endpoint is not deployed; callers treat that as "unknown".
   */
  nextEvents:   (ids)            => api.get('/v1/customers/next-events', { params: { ids: (ids || []).join(',') } })
                                      .then(r => r.data?.data ?? r.data),
};
